import PropTypes from 'prop-types';

export function EmptyCart({
  title = 'Lorem ipsum dolor sit amet consectetur adipiscing elit.',
  text = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  link = '/',
  linkText = 'Find a Sydney experience',
}) {
  return (
    <div>
      <h4 className="">{title}</h4>
      <div className="my-3">{text}</div>
      <a className="btn btn-primary text-decoration-none" href={link}>
        {linkText}
      </a>
    </div>
  );
}

EmptyCart.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string,
  linkText: PropTypes.string,
};
